var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specification",class:{ inactive: !this.visible[this.section] && !this.highlights.includes(this.spec) }},[_c('span',[_vm._v(_vm._s(_vm.specs[_vm.spec].name))]),(_vm.specs[_vm.spec].tooltip)?_c('Tooltip',{attrs:{"content":_vm.specs[_vm.spec].tooltip}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }